import { Signal, computed, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BAND_STUDIO_VIEW } from './capabilities';
import { CapabilityAccessService } from './capability-access.service';
import {
  BAND_STUDIO_ENABLED_FLAG_KEY,
  FeatureFlagService,
} from '../feature-flags/feature-flag.service';

/**
 * Rollout gate for Bands Studio (Pricing → Models): the `band-studio-enabled` Amplitude
 * flag lets it roll out without a redeploy. Who may use it is the `band_studio.view`
 * permission, which each Studio route checks with `capabilityGuard` beside this guard.
 */
export const bandStudioGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const flags = inject(FeatureFlagService);

  await flags.ready();
  const enabled = flags.isEnabledWithFallback(
    BAND_STUDIO_ENABLED_FLAG_KEY,
    environment.features.bandStudio
  );
  return enabled || router.createUrlTree(['/home']);
};

/**
 * The Studio routes' two checks — this rollout flag and `band_studio.view` — for a link into the
 * Studio from another page, so the link shows only where its route would open (GF-6380).
 */
export function bandStudioAdmits(): Signal<boolean> {
  const flag = inject(FeatureFlagService).enabledWithFallback(
    BAND_STUDIO_ENABLED_FLAG_KEY,
    environment.features.bandStudio
  );
  const access = inject(CapabilityAccessService);
  return computed(() => flag() && access.allows(BAND_STUDIO_VIEW));
}
